import { useMemo } from 'react';

import { ComparisonViewColumn } from '@/types/schema';

export const useSortedColumns = (
  columns: ComparisonViewColumn[],
  selectedBaselineSessionId?: string | null,
  addedSessions?: string[]
) => {
  return useMemo(() => {
    const otherSessionsSorted = columns.filter(
      (column) =>
        !column['sessionId'] ||
        column['sessionId'] !== selectedBaselineSessionId
    );
    otherSessionsSorted.sort((a, b) => {
      const aId = a['sessionId'];
      const bId = b['sessionId'];
      const addedSessionsArray = addedSessions ?? [];
      if (
        addedSessionsArray.includes(aId) &&
        !addedSessionsArray.includes(bId)
      ) {
        return 1;
      }
      if (
        addedSessionsArray.includes(bId) &&
        !addedSessionsArray.includes(aId)
      ) {
        return -1;
      }
      if (
        addedSessionsArray.includes(aId) &&
        addedSessionsArray.includes(bId)
      ) {
        return (
          addedSessionsArray.lastIndexOf(aId) -
          addedSessionsArray.lastIndexOf(bId)
        );
      }
      return 0;
    });
    const selectedBaselineColumn = selectedBaselineSessionId
      ? columns.find(
          (column) => column['sessionId'] === selectedBaselineSessionId
        )
      : null;
    return selectedBaselineColumn && columns.length > 1
      ? [selectedBaselineColumn, ...otherSessionsSorted]
      : otherSessionsSorted;
  }, [columns, selectedBaselineSessionId, addedSessions]);
};
